document.addEventListener('DOMContentLoaded', function () {
    var courseCardsContainer = document.getElementById('course-cards');
    // Function to gather selected filters
    function getSelectedFilters(isInitialLoad = false) {
        console.log(isInitialLoad);
        var categories = $('#categories input[type=checkbox]:checked').map(function () {
            return $(this).val();
        }).get();

        var fromMonth = $('#fromMonth').val();
        var fromYear = $('#fromYear').val();
        var toMonth = $('#toMonth').val();
        var toYear = $('#toYear').val();

        var currentDate = new Date();
        var formattedDay = isInitialLoad ? currentDate.getDate().toString().padStart(2, '0') : '01';

        var fromDateString = fromMonth + '/' + formattedDay + '/' + fromYear + " 12:00:00 AM";
        var lastDayOfToMonth = new Date(toYear, toMonth, 0).getDate(); // Day 0 is the last day of the previous month
        var toDateString = toMonth + '/' + lastDayOfToMonth + '/' + toYear + " 12:00:00 AM";

        // Convert date strings to Date objects for comparison
        var fromDate = new Date(fromDateString);
        var toDate = new Date(toDateString);

        if (toDate < fromDate) {
            return null; // Or handle the error as needed
        }

        var states = $('#states input[type=checkbox]:checked').map(function () {
            return $(this).val();
        }).get();

        return {
            categories: categories,
            fromDate: fromDateString,
            toDate: toDateString,
            states: states,
            pageSize:$('#pageSize').val() ?? 24,
            page: 1
        };
    }

    function fetchFilteredCourses(filters) {
        // Show the loader
        $('.course-block-overlay').show();
        // Fetch courses via AJAX
        fetch('/services/our-services/middys-training-academy/training-courses/get-courses', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(filters)
        })
        .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
        })
        .then(data => {
            // Fade out the current content before replacing it
            $(courseCardsContainer).fadeOut('slow', function () {
                // Replace the content inside courseCardsContainer
                courseCardsContainer.innerHTML = data;
                // Fade in the new content
                $(courseCardsContainer).fadeIn('slow', function () {
                    // Read the input values after content is loaded
                    const totalPages = parseInt($('#total-pages').val(), 10);
                    const totalCourses = parseInt($('#total-courses').val(), 10);
                    const currentPage = parseInt($('#currentPage').val(), 10)
                    if (totalCourses > 24)
                    {
                        $('#pagination').show();
                        updatePagination(totalPages, currentPage)
                    }
                    else
                        $('#pagination').hide();

                    // Hide the loader
                    $('.course-block-overlay').fadeOut('slow');

                });
            });

        }).catch(error => {
            console.error('Error fetching courses:', error);
            courseCardsContainer.innerHTML = '<h2>Sorry, we could not load the courses at this time. Please try again later.</h2>';
            // Hide the loader in case of error
            $('.course-block-overlay').fadeOut('slow');
        });
    }

    function updatePagination(totalPages, currentPage) {
        // Get the pagination container
        const paginationContainer = $('.pagination');

        // Clear any existing pagination content
        paginationContainer.empty();

        // Add the 'previous' button
        const prevClass = currentPage > 1 ? '' : 'style="pointer-events: none;"';
        paginationContainer.append(`<li class="previous ${prevClass.length > 1 ? 'disabled' : ""}" ${prevClass}><a href="#">&#8249;</a></li>`);

        // Add the pages
        for (let i = 1; i <= totalPages; i++) {
            const activeClass = i === currentPage ? 'active' : '';
            paginationContainer.append(`<li class="${activeClass}"><a href="#">${i}</a></li>`);
        }

        // Add 'dots' if necessary (e.g., for many pages)
        if (totalPages > 3) {
            paginationContainer.append('<li class="dots"><a href="#">…</a></li>');
        }

        // Add the 'next' button
        const nextClass = currentPage < totalPages ? '' : 'style="pointer-events: none;"';
        paginationContainer.append(`<li class="next ${nextClass.length > 1 ? 'disabled' : ""}" ${nextClass}><a href="#">&#8250;</a></li>`);

        // Show pagination if totalPages > 0
        if (totalPages > 0) {
            paginationContainer.show();
        } else {
            paginationContainer.hide();
        }

        // Add event listeners for pagination links
        paginationContainer.find('li').not('.dots').on('click', function (e) {
            e.preventDefault();
            var newPage = $(this).text();
            if ($(this).hasClass('previous')) {
                newPage = currentPage - 1;
            } else if ($(this).hasClass('next')) {
                newPage = currentPage + 1;
            } else {
                newPage = parseInt(newPage, 10);
            }

            var filters = getSelectedFilters();
            if (filters != null) {
                filters.page = newPage;
                fetchFilteredCourses(filters);
            } else {
                setRefineSearchMessage();
            }
        });

        // Scroll to top of the content
        var topOfContentElement = document.querySelector('.product-tiles-block');
        if (topOfContentElement) {
            topOfContentElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    // Event listeners for filter changes
    $('.parent-category input[type=checkbox], #fromMonth, #fromYear, #toMonth, #toYear, #pageSize').on('change', function () {
        var filters = getSelectedFilters();
        if (filters != null) {
            fetchFilteredCourses(filters);
        } else {
            setRefineSearchMessage();
        }
    });

    // Clear all filters when the "Clear all filters" link is clicked
    $('.clear-filter').on('click', function (e) {
        e.preventDefault();

        // Uncheck all checkboxes
        $('.parent-category input[type=checkbox]').prop('checked', false);

        // Get the current month and year
        var { currentMonth, currentYear } = getCurrentMonthAndYear();

        // Reset the date inputs to current month and year
        $('#fromMonth').val(currentMonth);
        $('#fromYear').val(currentYear);
        $('#toMonth').val(12);
        $('#toYear').val(currentYear);

        // Fetch courses with default filter values
        fetchFilteredCourses(getSelectedFilters());
    });

    // Function to get the current month and year
    function getCurrentMonthAndYear() {
        var date = new Date();
        var currentMonth = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-indexed, so add 1
        var currentYear = date.getFullYear().toString();
        return { currentMonth: currentMonth, currentYear: currentYear };
    }

    function setRefineSearchMessage()
    {
        courseCardsContainer.innerHTML = '<h2>No courses found, please refine search as "To Date" can`t be less than "From Date".</h2>';
    }

    // Initial fetch to load courses based on default filter values
    fetchFilteredCourses(getSelectedFilters(true));

});